import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'JushuitanOrder',
    column_type: 'id',
  },
  created_at: {
    model_name: 'JushuitanOrder',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'JushuitanOrder',
    column_type: 'datetime',
  },
  o_id: {
    model_name: 'JushuitanOrder',
    column_type: 'integer',
  },
  so_id: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  shop: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'shop',
      model_name: 'JushuitanShop',
    },
  },
  shop_id: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'shop',
      model_name: 'JushuitanShop',
    },
  },
  status: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  modified: {
    model_name: 'JushuitanOrder',
    column_type: 'datetime',
  },
  customer_jushuitan_order_relation: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_jushuitan_order_relation',
      model_name: 'CustomerJushuitanOrderRelation',
    },
  },
  key: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_jushuitan_order_relation',
      model_name: 'CustomerJushuitanOrderRelation',
    },
  },
  created: {
    model_name: 'JushuitanOrder',
    column_type: 'datetime',
  },
  amount: {
    model_name: 'JushuitanOrder',
    column_type: 'decimal',
  },
  customer: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  customer_id: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  user: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'JushuitanOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  pay_amount: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  shop_name: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  shop_site: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  items: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  freight: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  logistics_company: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  remark: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  buyer_message: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  shop_buyer_id: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  free_amount: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  sent_at: {
    model_name: 'JushuitanOrder',
    column_type: 'datetime',
  },
  paid_amount: {
    model_name: 'JushuitanOrder',
    column_type: 'decimal',
  },
  order_date: {
    model_name: 'JushuitanOrder',
    column_type: 'datetime',
  },
  can_edit_key: {
    model_name: 'JushuitanOrder',
    column_type: 'boolean',
  },
  can_bind_customer: {
    model_name: 'JushuitanOrder',
    column_type: 'boolean',
  },
  can_unbind_customer: {
    model_name: 'JushuitanOrder',
    column_type: 'boolean',
  },
  receivable_amount: {
    model_name: 'JushuitanOrder',
    column_type: 'decimal',
  },
  received_amount: {
    model_name: 'JushuitanOrder',
    column_type: 'decimal',
  },
  is_even: {
    model_name: 'JushuitanOrder',
    column_type: 'boolean',
  },
  real_freight: {
    model_name: 'JushuitanOrder',
    column_type: 'decimal',
  },
  l_id: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
  out_amount: {
    model_name: 'JushuitanOrder',
    column_type: 'decimal',
  },
  receive_ignored: {
    model_name: 'JushuitanOrder',
    column_type: 'boolean',
  },
  can_receive_ignore: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
